module.exports = {
    Unknown: "Unknown",
    Classic: "Classic",
    Baccarat: "Baccarat",
}